import React from 'react'
import { useBox } from '@react-three/cannon'

export const Stick = ({ ...props }) => {
    const { position=[-0.74, 1.62, 0.05], rotation=[0, 2.1, 0], args = [0.4, 0.02, 0.02] } = props;
    const [ref] = useBox(() => ({
        mass: 0,
        position,
        rotation,
        type: 'Static',
        args,
    }), null, [position, rotation, args]);

    return (
        <mesh ref={ref}>
            <boxGeometry attach="geometry" args={args} />
            <meshPhongMaterial color={0xf0f0ff} />
        </mesh>
    )
}
export default Stick;